import type { FaireProductEntity } from "../../entity_types/product";

export const atc_goes_well_4: FaireProductEntity = {
  token: "atc_goes_well_4",
  type: "product",
  name: "Puffy Drawstring Backpack",
  brandName: "Baggu",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/fb67a202fd97ec11e429a3ef590a1d7ece074093c20f2d98e61e12a075c8397b.jpeg",
  priceDollars: 32,
  msrpDollars: 64,
  description: "Recommended accessory for ATC flow.",
  tags: ["goes-well-with", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
